export default __webpack_public_path__ + "static/media/xd.291f340a.svg";